/** Which Drive surface a list is rendered on — drives columns, menus, shortcuts. */
export type DriveVariant = "folder" | "recent" | "starred" | "trash" | "search" | "shared";

export type ViewMode = "list" | "grid";

export const isViewMode = (v: unknown): v is ViewMode => v === "list" || v === "grid";
